module.exports = __webpack_public_path__ + "img/tile-agr2.0f92c126.jpg";